<template lang="pug">
  ev-autocomplete(
    v-model="inputValue"
    :items="items"
    label="Требования к участникам"
    item-text="name"
    item-value="id"
    multiple
    :loading="loading"
    v-bind="$attrs"
  )
</template>

<script>
import directoryService from '@/services/API/directories';

export default {
  props: {
    value: { type: [Array, String], default: () => [] },
    serializeValue: { type: Function, default: (v) => v },
  },
  data() {
    return {
      items: [],
      loading: true,
    };
  },
  computed: {
    inputValue: {
      get() {
        const { value } = this;
        const output = Array.isArray(value) ? value : [].concat(value || []);
        return this.serializeValue(output);
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  created() {
    directoryService
      .getEventRequirements()
      .then((response) => {
        this.items = response.data.data;
      })
      .finally(() => {
        this.loading = false;
      });
  },
};
</script>
